import { useEffect, useState } from 'react';

/** A tiny hash router: "#/pipeline" becomes ["pipeline"], "#/car/abc" becomes ["car", "abc"]. */
export function parseHash(hash: string): string[] {
  const path = hash.replace(/^#\/?/, '').split('?')[0];
  return path === '' ? [] : path.split('/').map(decodeURIComponent);
}

export function useHashRoute(): string[] {
  const [route, setRoute] = useState(() => parseHash(window.location.hash));
  useEffect(() => {
    const on = () => setRoute(parseHash(window.location.hash));
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return route;
}

export const go = (path: string): void => {
  window.location.hash = path.startsWith('/') ? path : `/${path}`;
};
